import { generateSrcSet, getImageVariants } from '@ori/image-sizes-helper';
import useTestId from '@ori/testid-generator';
import { useTheme } from '@ori-ui/mui';
import { useMemo } from 'react';
import { TOP_BANNER_IMAGE } from "./constants";
import { Image } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Component for displaying image background in TopBanner. For falsy value in `imageUrl` returns `null`.
 */
export var TopBannerImage = function TopBannerImage(_ref) {
  var imageUrl = _ref.imageUrl,
    backgroundColor = _ref.backgroundColor,
    title = _ref.title;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useTheme = useTheme(),
    palette = _useTheme.palette;
  var imagesVariants = useMemo(function () {
    return {
      url: imageUrl !== null && imageUrl !== void 0 ? imageUrl : '',
      backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : palette.common.white,
      params: [{
        width: 640,
        quality: 50
      }, {
        width: 767,
        quality: 50
      }, {
        width: 1024,
        quality: 90
      }, {
        width: 1440,
        quality: 80
      }, {
        width: 1536,
        quality: 50
      }, {
        width: 1920,
        quality: 50
      }, {
        width: 2732,
        quality: 50
      }]
    };
  }, [backgroundColor, imageUrl, palette.common.white]);
  if (!imageUrl) {
    return null;
  }
  var images = getImageVariants(imagesVariants);
  return /*#__PURE__*/_jsx(Image, {
    alt: title !== null && title !== void 0 ? title : imageUrl,
    "data-testid": getTestId(TOP_BANNER_IMAGE),
    srcSet: generateSrcSet(images)
  });
};
//# sourceMappingURL=TopBannerImage.js.map